'use client';
import type { ReactNode } from 'react';
import { useTheme } from './ThemeProvider';

export const ThemeWrapper = ({ children }: { children: ReactNode }) => {
    const { theme } = useTheme();

    return <div data-theme={theme}>{children}</div>;
};
